import config from '../config';
import fetch from 'cross-fetch';
import store from 'store2';
import { push } from 'react-router-redux';
import { getChartData } from '../actions/analytic';
import { addNotification as notify } from 'reapop';

export function getChart(data) {
  const userAuth = store.get('user');
  return dispatch => {
    return fetch(`${config.apiEndpoint}/analytic`, {
        method: 'POST',
        body: JSON.stringify(data),
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `bearer ${userAuth.api_token}`,
        },
        credentials: 'same-origin'
      })
      .then((response) => {
        return response.json();
      })
      .then(json => {
        if (json) {
          // Set login data
          dispatch(getChartData(json));
        }
      })
      .catch(response => {
        dispatch(notify({
          title: 'Get chart data',
          message: 'Failed to load chart data',
          status: 'error',
          position: 'tr',
          dismissible: true,
          dismissAfter: 3000
        }));
      });
  }
}



// WEBPACK FOOTER //
// ./src/api/analytics.js